import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-react';

import ActionCard from 'components/ActionCard';
import { getFancyboxButtonShareTpl } from 'components/FancyboxButtons/FancyboxButtonShare';
import Image from 'components/Image';
import SharingPopup from 'components/SharingPopup';
import StorageHandler from 'config/StorageHandler';
import { appContentUrl, storageKeys } from 'config/settings.json';
import { renderToString } from 'react-dom/server';

const handleClick = (itemID, email, language) => {
  const url = `https://travproconnect.com/profile/${itemID}?app_id=${
    import.meta.env.VITE_APP_ID
  }&email=${email}&mobile=true&lang=${language}`;
  window.ReactNativeWebView.postMessage(`webview:${url}`);
};

export default class ShowcaseCollectionCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
    };
  }

  componentDidMount() {
    // Set user object in state
    this.getUser();
  }

  getUser() {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = 'guest';
      if (userObj && userObj) {
        ({ email } = userObj);
      }
      this.setState({ email });
    });
  }

  render() {
    const { appId, image, subtitle, title, language } = this.props;
    const { email } = this.state;

    let { itemID } = this.props;
    itemID = Number(itemID);

    const fancyOptions = {
      infobar: true,
      thumbs: {
        autoStart: true,
        axis: 'x',
      },
      baseClass: 'customBox',
      buttons: ['thumbs', 'share', 'close'],
      share: {
        tpl: renderToString(<SharingPopup url="" />),
      },
      btnTpl: { share: getFancyboxButtonShareTpl() },
    };

    let newImage = `${appContentUrl}${appId}/salesCompanion/new_${image}`;
    if (appId > 500) {
      newImage = image;
    }

    let copy = subtitle;
    copy = new DOMParser().parseFromString(copy, 'text/html');
    copy = copy.body.textContent || '';
    if (copy.length > 20) {
      copy = `${copy.substring(0, 90)}...`;
    }

    const params = new URLSearchParams(window.location.search);

    if (params.get('mobile')) {
      return (
        <div className="showcaseCollection__Card">
          <div
            className="showcaseCollection__Grid--item"
            onClick={() => {
              return handleClick(itemID, email, language);
            }}
          >
            {/* Dummy image to fool fancybox thumbnails process */}
            <div className="imageContainer">
              {image && <Image src={newImage} alt={image} gradient={false} className="showcaseCollection__image" />}
            </div>
            <div id={`${title.toLowerCase().replace(' ', '_')}`} className="textContainer">
              <ActionCard title={title} superTitle={copy} background />
              <div className="showcase">
                <i>{i18n.translate('general.viewItem')} &gt;</i>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="showcaseCollection__Card">
        <div
          className="showcaseCollection__Grid--item"
          data-src={`https://travproconnect.com/profile/${itemID}?lang=${language}&email=${email}&app_id=${
            import.meta.env.VITE_APP_ID
          }`}
          data-type="iframe"
          data-fancybox={itemID}
          dataOptions={JSON.stringify(fancyOptions)}
          data-fancybox-trigger={itemID}
        >
          {/* Dummy image to fool fancybox thumbnails process */}
          <div className="imageContainer">
            {image && <Image src={newImage} alt={image} gradient={false} className="showcaseCollection__image" />}
          </div>
          <div id={`${title.toLowerCase().replace(' ', '_')}`} className="textContainer">
            <ActionCard title={title} superTitle={copy} background />
            <div className="showcase">
              <i>{i18n.translate('general.viewItem')} &gt;</i>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ShowcaseCollectionCard.propTypes = {
  appId: PropTypes.number.isRequired,
  image: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  language: PropTypes.string,
  itemID: PropTypes.number.isRequired,
};

ShowcaseCollectionCard.defaultProps = {
  language: 'en',
  image: '',
  subtitle: '',
  title: '',
};
